import React, { useState } from 'react';
import { Button, Modal, Input } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';

import defaultImage from '../../../../Maintenance/images/default.jpg';
import './style.css';
import { useTranslation } from 'react-i18next';
import PhotoInputButton from './PhotoInputButton';

const PhotoCapture = ({
  steps,
  photoCaptureHandler,
  deleteFileHandler,
  createNewCameraSubStep,
  id, // Add unique identifier prop
}) => {
  const { t } = useTranslation();

  // Use the id to create a unique key for the photos state
  const [photos, setPhotos] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newPhotoTitle, setNewPhotoTitle] = useState('');

  const handlePhotoCapture = async (index, event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return; // Exit if no file was selected
    const file = files[0];
    const newPhotos = [...photos];

    const uploadResponse = await photoCaptureHandler(index, event); // Call original handler if needed

    newPhotos[index] = {
      image: URL.createObjectURL(file),
      title: steps[index]?.title ?? t('photo'),
      blobPath: uploadResponse.blobPath,
    };

    // Save Image Path (uploadResponse.blobPath)

    setPhotos(newPhotos);

    console.log('Upload response:', uploadResponse);
    // Reset the file input
    event.target.value = '';
  };

  const handlePhotoClick = async (index) => {
    const newPhotos = [...photos];
    if (photos[index]) {
      // Remove the uploaded photo
      const blobPathToDelete = photos[index].blobPath;
      newPhotos[index] = null;
      const response = await deleteFileHandler(index, blobPathToDelete);
      console.log('Delete response:', response);
    } else {
      document.querySelectorAll(`.photoCaptureInput[data-id="${id}"]`)[index].click();
    }
    setPhotos(newPhotos);
  };

  const handleAddPhoto = () => {
    setIsModalOpen(true);
  };

  const handleModalOk = () => {
    if (newPhotoTitle.trim()) {
      createNewCameraSubStep(newPhotoTitle);
      setIsModalOpen(false);
      setNewPhotoTitle('');
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setNewPhotoTitle('');
  };

  return (
    <div className='photoCaptureContainer'>
      {steps.map((step, index) => (
        <div className='photoCaptureStep' key={`${id}-${index}`}>
          <div className='imagePreview'>
            <img
              src={photos[index]?.image ?? defaultImage}
              alt={step.title}
              onClick={() => handlePhotoClick(index)}
            />
          </div>
          <div className='infoColumn'>
            <div className='description'>
              <h3>{step.title}</h3>
              {step.description?.hints?.map((hint, index) => (
                <p key={index}>{hint}</p>
              ))}
            </div>
            <PhotoInputButton
              index={index}
              handlePhotoCapture={handlePhotoCapture}
              handlePhotoClick={handlePhotoClick}
              photos={photos}
              t={t}
              id={id} // Pass the id to the button component
            />
          </div>
        </div>
      ))}
      {steps.length < 5 && (
        <Button
          className='addPhotoButton'
          size='large'
          icon={<PlusCircleOutlined />}
          style={{
            borderColor: '#1777FF',
            background: 'white',
            color: '#1777FF',
          }}
          onClick={handleAddPhoto}
        >
          {t('add_photo')}
        </Button>
      )}

      <Modal
        className='photoCaptureModal'
        centered
        title={t('add_photo')}
        open={isModalOpen}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText={t('confirm-btn')}
        cancelText={t('cancel-btn')}
      >
        <Input
          placeholder={t('enter_photo_title')}
          value={newPhotoTitle}
          onChange={(e) => setNewPhotoTitle(e.target.value)}
          style={{ width: '100%' }}
          maxLength={80}
        />
      </Modal>
    </div>
  );
};

export default PhotoCapture;
